import { Button, Space, Select } from 'antd';
import { useGetIdentity, useLogout } from '@refinedev/core';
import { useTranslation } from 'react-i18next';

export function HeaderControls() {
  const { t, i18n } = useTranslation();
  const { mutate: logout } = useLogout();
  const { data: identity } = useGetIdentity<{ email?: string; name?: string }>();

  return (
    <Space size="middle" style={{ padding: '0 16px' }}>
      <Select
        size="small"
        value={i18n.language}
        onChange={(lng) => {
          void i18n.changeLanguage(lng);
          localStorage.setItem('admin-refine.locale', lng);
        }}
        options={[
          { value: 'he', label: 'עברית' },
          { value: 'en', label: 'English' },
        ]}
        aria-label={t('common.language')}
      />
      {identity?.email ? <span style={{ opacity: 0.7 }}>{identity.email}</span> : null}
      <Button size="small" onClick={() => logout()}>
        {t('auth.logout')}
      </Button>
    </Space>
  );
}
